import { Deserializable } from '../protocols/deserializable';
import { Asset } from '../asset/dto/asset';

export class SelfEnrolmentLogo implements Deserializable {
  public id!: string;
  public attachment!: Asset;

  onDeserialize() {
    this.attachment = window?.injector?.Deserialize?.instanceOf(Asset, this.attachment);
  }
}
